// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__G0afX","col":"styles_col__3m9hx"};